import { createFileRoute } from '@tanstack/react-router'
import { ManageUsers } from 'pages/manageUsers/ManageUsers'

export const Route = createFileRoute('/users/$orgID')({
  component: ManageUsers,
  staticData: {
    title: 'Manage Users',
  },
})
